module.exports = __webpack_public_path__ + "static/media/inetcpl_4432.5b69dcf7.ico";